<template>
  <SecondaryBackground>
    <div class="mt-5 sm:mt-16">
      <div>
        <form @submit="submit">
          <DefaultCard class="min-w-full sm:min-w-30 max-w-xl mx-auto">
            <Heading class="mb-16" center>Enter New Password</Heading>
            <div class="mb-4">
              <label for="password" class="text-sm">New Password<small>*</small></label>
              <input type="password" class="input mt-2" id="password" v-model="password" />
            </div>
            <div class="mb-12">
              <label for="repeatPassword" class="text-sm">Repeat New Password<small>*</small></label>
              <input type="password" class="input mt-2" id="repeatPassword" v-model="repeatPassword" />
              <span class="text-canceled block text-xs mt-2 pl-2" v-if="errors.passwordConfirmation">
						Please, repeat your password correctly
					</span>
            </div>
            <button
              type="submit"
              class="btn w-full btn-primary rounded-lg font-semibold sm:px-12"
              :disabled="!canSubmit || loading"
            >
              <span v-if="!loading">Save</span>
              <Spinner class="mx-auto" v-if="loading" />
            </button>
          </DefaultCard>
        </form>
      </div>
    </div>
  </SecondaryBackground>
</template>

<script>
  import SecondaryBackground from "@/components/common/layout/SecondaryBackground"
  import DefaultCard from "../components/common/layout/DefaultCard"
  import Heading from "../components/common/Heading"
  import Spinner from "../components/common/Spinner"
  import api from '../api'
  import {Utils} from "@/utils"

  export default {
    name: "ResetPassword",
    components: { Spinner, Heading, DefaultCard, SecondaryBackground },
    data() {
      return {
        loading: false,
        password: '',
        repeatPassword: '',
        token: '',
        email: '',
        errors: {},
      }
    },
    computed: {
      canSubmit() {
        return this.password && this.password.length >= 8 && this.repeatPassword && this.repeatPassword.length >= 8;
      },
      isError() {
        return !Utils.isObjectEmpty(this.errors);
      }
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        this.token = this.$route.query.token;
        this.email = this.$route.query.email;
        if (!this.token || !this.email) {
          this.$router.push('/forgot-password');
        }
      },

      submit(event) {
        event.preventDefault();
        if (this.password !== this.repeatPassword) {
          this.errors = {passwordConfirmation: true}
        } else {
          this.resetPassword();
        }
      },

      async resetPassword() {
        this.errors = {};
        this.loading = true;

        try {
          await api.resetPassword({
            password: this.password,
            password_confirmation: this.repeatPassword,
            token: this.token,
            email: this.email
          });
          this.loading = false;
          await this.$router.push('/auth/sign-in')
        } catch (error) {
          this.errors = error.errors ? error.errors : error;
          this.loading = false;
        }
      }
    }
  }
</script>
